import { AuthForm } from '@/components/auth-form';
import { EmailOtpVerify } from './EmailOtpVerify';
import { ErrorResponse } from 'oidc-client-ts';
import { useState } from 'react';
import { LoginStepper } from './LoginStepper';

interface OtpAuthProps {
  userCredentials: { username: string; password: string };
  handleAuthSuccess: () => void;
  redirectUrl?: string;
  setShowOtp: (showOtp: boolean) => void;
  setUserCredentials: (userCredentials: { username: string; password: string }) => void;
}

export const OtpAuth = ({
  redirectUrl,
  userCredentials,
  handleAuthSuccess,
  setShowOtp,
  setUserCredentials,
}: OtpAuthProps) => {
  const [authError, setAuthError] = useState<ErrorResponse | undefined>(undefined);

  return (
    <AuthForm
      error={authError}
      onBack={() => {
        setAuthError(undefined);
        setShowOtp(false);
        setUserCredentials({ username: '', password: '' });
      }}
    >
      <LoginStepper currentStep={2} />

      <EmailOtpVerify
        userCredentials={userCredentials}
        onVerifySuccess={handleAuthSuccess}
        onVerifyError={setAuthError}
        redirectUrl={redirectUrl}
      />
    </AuthForm>
  );
};
